import React, { createRef, useCallback } from 'react';

import { ChevronDownMini, ChevronUpMini } from '@xsolla/ui-icons';

import { IconWrapper, StyledButton, StyledInput, Wrapper } from './styles';
import { Props } from './types';

const InputNumber = ({
  hideArrows = false,
  compact = false,
  inline = false,
  max,
  min,
  ...props
}: Props): JSX.Element => {
  const inputRef = createRef<HTMLInputElement>();

  const onBlur = useCallback(() => {
    if (inputRef && inputRef.current) {
      const currValue = Number(inputRef.current.value);

      if (max && currValue > max) {
        inputRef.current.value = max.toString();
      }
      if (min && currValue < min) {
        inputRef.current.value = min.toString();
      }

      forceReactInputOnChange(inputRef.current);
    }
  }, [inputRef]);

  const changeValue = useCallback(
    (value: number) => {
      if (inputRef && inputRef.current) {
        if (!inputRef.current.value) {
          inputRef.current.value = min ? min.toString() : '0';
        } else if (max && value <= max && min && value >= min) {
          inputRef.current.value = value.toString();
        }

        forceReactInputOnChange(inputRef.current);
      }
    },
    [inputRef]
  );

  const forceReactInputOnChange = (input: HTMLInputElement) => {
    // @ts-expect-error NOTE: clear the interval value to force an actual change
    // eslint-disable-next-line no-underscore-dangle
    input._valueTracker?.setValue('');
    input.dispatchEvent(new Event('input', { bubbles: true }));
  };

  const upClick = useCallback(() => {
    if (inputRef && inputRef.current) {
      changeValue(Number(inputRef.current.value) + 1);
    }
  }, [inputRef]);

  const downClick = useCallback(() => {
    if (inputRef && inputRef.current) {
      changeValue(Number(inputRef.current.value) - 1);
    }
  }, [inputRef]);

  return (
    <Wrapper inline={inline}>
      <StyledInput compact={compact} type="number" ref={inputRef} onBlur={onBlur} {...props} />
      {!hideArrows && (
        <IconWrapper>
          <StyledButton type="button" look="icon" palette="brand" onClick={upClick}>
            <ChevronUpMini />
          </StyledButton>
          <StyledButton type="button" look="icon" palette="brand" onClick={downClick}>
            <ChevronDownMini />
          </StyledButton>
        </IconWrapper>
      )}
    </Wrapper>
  );
};

export default InputNumber;
